module.exports = __webpack_public_path__ + "static/media/edit_01aad3.70029a45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/edit_01aad3.svg
// module id = 492
// module chunks = 51